import React from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../ui/Modal";
import Button from "../ui/Button";

const CareEconomyPopup = ({ open, onClose, onExplore, transformOrigin }) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      onClose={onClose}
      transformOrigin={transformOrigin}
      header={
        <h2 className="text-2xl font-bold text-black text-center mb-6 font-playfair">
          The Care Economy
        </h2>
      }
      footer={
        <div className="flex justify-center pt-6">
          <Button
            title="Explore"
            onClick={() => {
              if (onExplore) {
                onExplore();
              } else {
                onClose();
                navigate("/tabs?tab=care-economy");
              }
            }}
          />
        </div>
      }
    >
      <div className="space-y-3">
        <p className="text-base font-normal leading-loose text-black mb-4">
          The care economy is associated with economic activities related to
          providing care for individuals, which include both paid and unpaid
          work. This section focuses on the many attributes of what comprises
          the care economy, especially in the context of unpaid informal care or
          family caregiving.
        </p>

        <p className="text-base font-normal leading-loose text-black mb-3">
          The topics in this section include:
        </p>

        <ul className="space-y-1 text-base font-normal leading-loose text-black list-disc pl-6 mb-6">
          <li>What is the care economy?</li>
          <li>Why does the care economy matter?</li>
          <li>What does a strong care economy need?</li>
          <li>
            Schemes and policies to strengthen the care economy (General and
            global context)
          </li>
          <li>
            Care economy scenarios in the Nooraverse (India, Bangladesh,
            Indonesia, Nepal)
          </li>
          <li>
            Existing schemes and policies governing the care economy in each of
            these countries
          </li>
        </ul>
      </div>
    </Modal>
  );
};

export default CareEconomyPopup;
